import axios from 'axios';
import { ITEMS_LIST_URL, GET_MENUS } from '../../util/urls';
import { NutritionStringToObject, GetOrderType } from '../../lib/helper.js';
import { orderBy, filter, isEmpty, find, map } from 'lodash';
import { mapProps } from 'recompose';
import { Memoize } from '../../socket/memoize';

//Action Types
export const SELECT_CATEGORY = 'SELECT_CATEGORY',
  FETCH_CATEGORY = 'FETCH_CATEGORY',
  SELECT_SUBCATEGORY = 'SELECT_SUBCATEGORY',
  CHANGE_MENUITEMS = 'CHANGE_MENUITEMS',
  LOAD_CATEGORY = 'LOAD_CATEGORY',
  LOADING = 'LOADING',
  LOAD_PAGINATION_MENU_ITEMS = 'LOAD_PAGINATION_MENU_ITEMS',
  UPDATE_MENUITEMS = 'UPDATE_MENUITEMS',
  UNSET_MENU = 'UNSET_MENU',
  LOADINFINITE_MENUITEMS = 'LOADINFINITE_MENUITEMS',
  ISINFINITEBOOLVALUE = 'ISINFINITEBOOLVALUE',
  ADDMENUIDS = 'ADDMENUIDS',
  CHANGE_CATEGORYID = 'CHANGE_CATEGORYID',
  INFINITE_SCROLL = 'INFINITE_SCROLL',
  CLICKBOOLEAN = 'CLICKBOOLEAN';

//Actions
export function unsetMenu() {
  return dispatch => {
    dispatch({
      type: UNSET_MENU,
    });
  };
}

export function selectCategory(id, selectFirstByDefault = true) {
  return dispatch => {
    return new Promise(resolve => {
      dispatch({
        type: SELECT_CATEGORY,
        id,
        selectFirstByDefault,
      });
      resolve();
    });
  };
}

export const getFirstMenuGroup = list => {
  return find(list, { parentid: '-1' }) || {};
};

export const getMenuItemFormat = list => {
  return filter(list, function(listData) {
    return listData.parentid === '-1';
  });
};

export const getAllItems = (menuItemsFormat, list) => {
  return map(menuItemsFormat, function(menuData) {
    let itemsData = filter(list, function(listData) {
      return menuData.id === listData.parentid;
    });
    menuData.mainMenuItem = itemsData;
    return menuData;
  });
};

export const getFirstCategory = list => {
  const { id = 0, orderby = 0 } = getFirstMenuGroup(list);
  const categoryDetailsArray = filter(list, { parentid: id });
  const sortedArray =
    orderby === 'alpha' || orderby === '' || orderby === 0
      ? orderBy(categoryDetailsArray, 'text', 'asc')
      : categoryDetailsArray.sort((a, b) => {
          return a._order - b._order;
        });
  return isEmpty(sortedArray) ? {} : sortedArray[0];
};

/* Code related to LTG-284 */
/*export function loadCategory(menuCategories) {
  const list = menuCategories['menu_category'] || menuCategories;
  const { id = 0, orderby = 0, text = '' } = getFirstMenuGroup(list);
  const subCategoryDetails = getFirstCategory(list);
  const menuItemsFormat = getMenuItemFormat(list);
  const menuArray = getAllItems(menuItemsFormat, list);
  // const sortedMenuArray = map(menuArray, function(menuData) {
  //   menuData.mainMenuItem =
  //     menuData.orderby === 'alpha' || menuData.orderby === 0
  //       ? orderBy(menuData.mainMenuItem, 'text', 'asc')
  //       : orderBy(menuData.mainMenuItem, 'id', 'asc');
  //   return menuData;
  // });
  // console.log('sorted array', sortedMenuArray);
  return {
    type: LOAD_CATEGORY,
    menuCategories: menuCategories,
    mainMenuItemClicked: id,
    mainMenuOrderBy: orderby,
    mainMenuItemName: text,
    subMenuItemClicked: subCategoryDetails.id || 0,
    bannerTxt: subCategoryDetails.text || '',
    menuArray: menuArray,
  };
}*/

export function loadCategory(menuCategories) {
  const list = menuCategories['menu_category'] || menuCategories;
  const { id = 0, orderby = 0, text = '' } = getFirstMenuGroup(list);
  const subCategoryDetails = getFirstCategory(list);

  return {
    type: LOAD_CATEGORY,
    menuCategories: menuCategories,
    mainMenuItemClicked: id,
    mainMenuOrderBy: orderby,
    mainMenuItemName: text,
    subMenuItemClicked: subCategoryDetails.id || 0,
    bannerTxt: subCategoryDetails.text || '',
  };
}

export const loadCategories = function(tokenId, dataName, loadCategoriesData) {
  return dispatch => {
    const func = function(dispatch, tokenId, dataName, loadCategoriesData) {
      return axios
        .get(GET_MENUS + 'tokenId/' + tokenId + '/dataname/' + dataName)
        .then(res => {
          const menuCategories = JSON.parse(
            JSON.stringify(res.data.DataResponse)
          );
          if (menuCategories) {
            return dispatch(loadCategory(menuCategories));
          } else {
            return [];
          }
        });
    };
    return Memoize.memoizeCall({
      key: 'menu_items',
      func,
      args: [dispatch, tokenId, dataName, loadCategoriesData],
    });
  };
};

export const selectSubcategory = function(
  id,
  text,
  modeOfOrder,
  tokenId,
  jwt,
  dataName
) {
  return dispatch => {
    const func = function(
      dispatch,
      id,
      text,
      modeOfOrder,
      tokenId,
      jwt,
      dataName
    ) {
      const modeOfOrderStr = GetOrderType(modeOfOrder || 2);
      if (tokenId)
        return fetch(
          ITEMS_LIST_URL +
            'tokenId/' +
            tokenId +
            '/dataname/' +
            dataName +
            '/current_page/1/per_page/8/category_id/' +
            id +
            '/dining_option/' +
            modeOfOrderStr,
          {
            method: 'GET',
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json',
              Authorization: 'Bearer ' + btoa(jwt),
            },
          }
        )
          .then(res => {
            return res ? res.json() : false;
          })
          .then(data => {
            if (data) {
              let items = data.DataResponse.Items;
              items.forEach((item, index) => {
                items[index] = filterItem({
                  item,
                  isForcedIdSet:
                    item.forced[0] && item.forced[0].id ? true : false,
                });
              });
              const pagination = data.DataResponse.pagination;
              return new Promise(resolve => {
                dispatch(changeMenuItems(data, text, items, id, pagination));
                resolve();
              });
            } else {
              return false;
            }
          });
    };
    return Memoize.memoizeCall({
      key: 'menu_items',
      func,
      args: [dispatch, id, text, modeOfOrder, tokenId, jwt, dataName],
    });
  };
};

export function loadInfiniteSubcategory(
  id,
  mainMenuItemClicked,
  text,
  modeOfOrder,
  tokenId,
  jwt,
  dataName,
  prevItems,
  menuArrayItems
) {
  return dispatch => {
    const modeOfOrderStr = GetOrderType(modeOfOrder || 2);
    dispatch(infiniteScroll(true));
    if (tokenId)
      return fetch(
        ITEMS_LIST_URL +
          'tokenId/' +
          tokenId +
          '/dataname/' +
          dataName +
          '/current_page/1/per_page/8/category_id/' +
          id +
          '/dining_option/' +
          modeOfOrderStr,
        {
          method: 'GET',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + btoa(jwt),
          },
        }
      )
        .then(res => {
          return res ? res.json() : false;
        })
        .then(data => {
          if (data) {
            let items = data.DataResponse.Items;
            items.forEach((item, index) => {
              items[index] = filterItem({
                item,
                isForcedIdSet:
                  item.forced[0] && item.forced[0].id ? true : false,
              });
            });
            //let menuItemObject = Object.assign({ [id]: items }, prevItems);
            prevItems.push({ [id]: items });
            menuArrayItems.map(menuItem => {
              menuItem.mainMenuItem =
                menuItem.orderby === 'alpha' || menuItem.orderby === 0
                  ? orderBy(menuItem.mainMenuItem, 'text', 'asc')
                  : orderBy(menuItem.mainMenuItem, 'id', 'asc');
              if (menuItem.id === mainMenuItemClicked) {
                menuItem.mainMenuItem.map(subMenuItem => {
                  if (subMenuItem.id === id) {
                    subMenuItem['menuItems'] = items;
                  }
                });
              }
            });
            const pagination = data.DataResponse.pagination;
            return new Promise(resolve => {
              dispatch(
                loadInfiniteMenuItems(data, text, prevItems, menuArrayItems)
              );
              resolve();
            });
          } else {
            return false;
          }
        });
  };
}

export function loadInfiniteMenuItems(data, text, items, menuArrayItems) {
  return {
    type: LOADINFINITE_MENUITEMS,
    newItems: items,
    menuArray: menuArrayItems,
    bannerImage: data.DataResponse.bannerImage,
    bannerTxt: text,
  };
}

export function infiniteScrollDown(scrollValue) {
  return {
    type: INFINITE_SCROLL,
    infiniteScroll: scrollValue,
  };
}

export function assignItemValues(parentId, subItemId, orderBy) {
  return {
    type: ADDMENUIDS,
    mainMenuItemClicked: parentId,
    subMenuItemClicked: subItemId,
    orderBy: orderBy,
  };
}

export function changeCategoryId(subItemId) {
  return {
    type: CHANGE_CATEGORYID,
    subMenuItemClicked: subItemId,
  };
}

export function infiniteScroll(infiniteBoolValue) {
  return {
    type: ISINFINITEBOOLVALUE,
    infiniteBoolValue: infiniteBoolValue,
  };
}

export const filterItem = ({ item, isForcedIdSet }) => {
  if (item) {
    if (item.nutrition) {
      item.nutrition = NutritionStringToObject(item.nutrition);
    }
    item['isItemInBag'] = false;
    if (item.forced && item.forced.length > 0) {
      item.forced.forEach((option, index) => {
        if (
          option.type === null ||
          option.type === undefined ||
          option.type === 'choice' ||
          option.type === 'checklist'
        ) {
          if (isForcedIdSet && index === 0) {
            option['selected'] = true;
            option['addToBag'] = false;
          } else if (index === 1 && option.type === 'checklist') {
            option['selected'] = true;
            option['addToBag'] = false;
          } else {
            option['selected'] = false;
            option['addToBag'] = false;
          }

          if (option.option) {
            option.option.forEach((subOption, subOptionIndex) => {
              if (subOption.doption) {
                if (
                  (subOption.detour !== undefined && subOption.detour !== '') ||
                  !isForcedIdSet
                ) {
                  if (subOptionIndex === 0) {
                    subOption.doption['selected'] = true;
                    subOption.doption['addToBag'] = false;
                  } else if (
                    subOptionIndex === 1 &&
                    subOption.type === 'checklist'
                  ) {
                    subOption.doption['selected'] = true;
                    subOption.doption['addToBag'] = false;
                  } else {
                    subOption.doption['selected'] = false;
                    subOption.doption['addToBag'] = false;
                  }
                }
              }
            });
          }
        } else {
          item.forced.splice(index, 1);
        }
      });
    }
    if (item.optional && item.optional.length > 0) {
      item.optional.forEach((option, index) => {
        if (index === 0) {
          option['selected'] = true;
          option['addToBag'] = false;
        } else {
          option['selected'] = false;
          option['addToBag'] = false;
        }
      });
    }
  }
  return item;
};

export const loadPaginationItems = Memoize.memoizeFunc('menu_items', function(
  prevItems,
  id,
  current_page,
  tokenId,
  jwt,
  dataName,
  modeOfOrder
) {
  return dispatch => {
    let modeOfOrderStr = '';
    if (modeOfOrder === 1) modeOfOrderStr = 'Pickup';
    else if (modeOfOrder === 2) modeOfOrderStr = 'Delivery';
    else if (modeOfOrder === 3) modeOfOrderStr = 'Dine-in';

    if (tokenId) {
      return fetch(
        ITEMS_LIST_URL +
          'tokenId/' +
          tokenId +
          '/dataname/' +
          dataName +
          '/current_page/' +
          current_page +
          '/per_page/8/category_id/' +
          id +
          '/dining_option/' +
          modeOfOrderStr,
        {
          method: 'GET',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + btoa(jwt),
          },
        }
      )
        .then(res => res.json())
        .then(data => {
          let items = [];
          if (data.DataResponse && data.DataResponse.Items) {
            items = JSON.parse(JSON.stringify(data.DataResponse.Items));
          }
          if (items != null) {
            items.forEach((item, index) => {
              items[index] = filterItem({
                item,
                isForcedIdSet:
                  item.forced[0] && item.forced[0].id ? true : false,
              });
              prevItems.push(items[index]);
            });
          }

          return dispatch(
            loadPaginationMenuItems(
              items,
              prevItems,
              data.DataResponse.pagination
            )
          );
        });
    }
  };
});

export function changeMenuItems(data, text, items, id, pagination) {
  return {
    type: CHANGE_MENUITEMS,
    newItems: items,
    bannerImage: data.DataResponse.bannerImage,
    bannerTxt: text,
    subMenuItemClicked: id,
    pagination: pagination,
  };
}

export function updateSubMenuItem(id) {
  return {
    type: UPDATE_MENUITEMS,
    subMenuItemClicked: id,
  };
}

export function loadPaginationMenuItems(
  prevItems,
  newItems,
  // menuArrayItems,
  pagination
) {
  return {
    type: LOAD_PAGINATION_MENU_ITEMS,
    newItems: newItems,
    prevItems: prevItems,
    pagination: pagination,
    // menuArray: menuArrayItems,
  };
}

export function loading(status) {
  return {
    type: LOADING,
    status: status,
  };
}

export function subMenuClicked(boolValue) {
  return {
    type: CLICKBOOLEAN,
    boolStatus: boolValue,
  };
}

export const getNutrionOnNotSet = nutrition => {
  if (!nutrition) {
    return [
      { name: 'calories', unit: '', value: '0' },
      { name: 'proteins', unit: '', value: '0' },
      { name: 'fat', unit: 'g', value: '0' },
      { name: 'sodium', unit: 'g', value: '0' },
      { name: 'saturated_fat', unit: 'g', value: '0' },
      { name: 'carbs', unit: 'g', value: '0' },
      { name: 'fiber', unit: 'g', value: '0' },
      { name: 'sugar', unit: 'g', value: '0' },
    ];
  }

  return nutrition;
};



// WEBPACK FOOTER //
// ./src/views/menu/actions.js